/** @registry MultiSelect value: keeps only the selected values that the option list contains, so a MultiSelect shows no raw-id pill for an item the list no longer holds (for example, an archived user). */
export const toMultiSelectValue = (
  values: readonly string[],
  data: readonly { value: string }[],
): string[] => {
  const listed = new Set(data.map((option) => option.value));
  return values.filter((value) => listed.has(value));
};
